import { render, staticRenderFns } from "./List-Coupon-Offline.vue?vue&type=template&id=52554c4a&scoped=true"
import script from "./List-Coupon-Offline.vue?vue&type=script&lang=js"
export * from "./List-Coupon-Offline.vue?vue&type=script&lang=js"
import style0 from "./List-Coupon-Offline.vue?vue&type=style&index=0&id=52554c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52554c4a",
  null
  
)

export default component.exports